// * Import required libraries
import React from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import SigviewBanner from "../SigviewBanner";
import { updateUserBannerStatus } from "../../redux/actions";
import { masterTrackGaEvent } from "../../services/ga";

// * Define styles
const midPanelStyle = {
  width: "100%",
  display: "flex",
  justifyContent: "center",
  padding: "8px 0px",
  background: "transparent",
};

function BannerDisplay(props) {
  const { dispatch: ReduxDispatcher, user, allData } = props;
  const handleCloseBanner = () => {
    const payload = {
      status: false,
      originalMessage: allData.banner.message,
    };
    ReduxDispatcher(updateUserBannerStatus(payload));
    masterTrackGaEvent({
      category: "Menubar",
      action: "BannerNotificationHide",
      label: "1",
    });
  };

  return (
    <>
      {allData.banner.status &&
        (user.bannerStatus.status ||
          user.bannerStatus.originalMessage !== allData.banner.message) && (
          <div className={`mid-panel`} style={midPanelStyle}>
            <div
              style={{
                maxWidth: "700px",
                width: "100%",
                whiteSpace: "normal",
                wordBreak: "break-word",
                overflowWrap: "break-word",
              }}
            >
              <SigviewBanner
                title={allData.banner.message}
                handleCloseBanner={handleCloseBanner}
              />
            </div>
          </div>
        )}
    </>
  );
}

BannerDisplay.propTypes = {
  user: PropTypes.object,
  match: PropTypes.object,
};

const mapStateToProps = (state) => ({
  user: state.user,
  allData: state.data,
  changeFlag: state.changeFlag,
});

export default connect(mapStateToProps)(BannerDisplay);
